import { reCityConstants } from './constants'

const initialState =
	{
		list		    : [],
		isSending	    : false,
		error		    : null
	}

export default function (state = initialState, action){
	switch (action.type){
		case reCityConstants.GetCities.REQUEST:
			return {
				...state,
				isSending : true
			}
		case reCityConstants.GetCities.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case reCityConstants.GetCities.SUCCESS:
			return {
				...state,
				isSending : false,
				list : action.payload.result
			}
		case reCityConstants.ClearCities:
			return {
				...state,
				list : []
			}
		default:
			return state
	}
}